<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-body p-15 p-sm-20 p-md-25">
      <h3>{{ paimentNote.note_ref }}</h3>
      <br />
      <h5>
        Date de création :
        <b v-if="paimentNote.created_at">
          {{ getDate(paimentNote.created_at) }}</b
        >
        | <b> {{ paimentNote.zone_name }} </b> |
        <b>{{ paimentNote.agency_name }} </b> |
        <b>{{ paimentNote.for_name }} </b>
      </h5>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-md-6">
      <div
        v-if="paimentNote.statut == 0"
        class="card mb-25 border-0 rounded-0 bg-white letter-spacing"
      >
        <div class="card-header pb-2">
          <h5>List des nouveaux bons (Non Payés)</h5>
        </div>
        <div class="card-body p-15 p-sm-20 p-md-25">
          <div class="m-2">
            <div class="row">
              <div
                v-if="auth.can('ADD_BP_L')"
                class="col-12 col-md-3 d-flex justify-content-start mb-1 mb-md-0"
              >
                <button
                  v-if="paimentNote.statut == 0"
                  style="margin-right: 12px"
                  class="btn btn-success"
                  @click="AddNewBP"
                >
                  Ajouter
                </button>
              </div>
              <div class="col-12 col-md-9">
                <div class="custom-search d-flex justify-content-end">
                  <div class="form-group mb-0">
                    <div class="d-flex align-items-center">
                      <input
                        v-model="searchTearm"
                        placeholder="Chercher"
                        type="text"
                        class="form-control d-inline-block"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <vue-good-table
            :columns="columnsBP"
            :rows="PBRestList"
            :select-options="{
              selectOnCheckboxOnly: true,
              enabled: true,
              clearSelectionText: 'Annuler',
              selectionText: 'Colis Sélectionés',
              disableSelectInfo: true,
              selectAllByGroup: true,
            }"
            responsive
            :search-options="{
              enabled: true,
              externalQuery: searchTearm,
            }"
            @select-all="onSelectAllBP"
            @selected-rows-change="selectionChangedBP"
          >
            <template v-slot:table-row="props">
              <template v-if="props.column.field === 'infos'">
                <span>{{ props.row.zone_name }}</span
                ><br />
                <span>{{ props.row.agency_name }}</span
                ><br />
                <span>{{ props.row.for_name }}</span
                ><br />
                <span>{{ getDate(props.row.created_at) }}</span
                ><br />
              </template>
              <template v-else-if="props.column.field === 'note_ref'">
                <b>{{ props.row.note_ref }}</b>
              </template>
              <template v-else-if="props.column.field === 'total'">
                <span
                  ><b>{{ props.row.total }}</b> DH</span
                >
              </template>
              <template v-else-if="props.column.field === 'reste_amount'">
                <span
                  ><b>{{ props.row.reste_amount }}</b> DH</span
                >
              </template>
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>
          </vue-good-table>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-6">
      <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
        <div class="card-header pb-2">
          <h5>List des bons ajoutés</h5>
        </div>
        <div class="card-body p-15 p-sm-20 p-md-25">
          <div class="m-2">
            <div class="row">
              <div
                v-if="auth.can('ADD_BP_L')"
                class="col-12 col-md-3 d-flex justify-content-start mb-1 mb-md-0"
              >
                <button
                  v-if="paimentNote.statut == 0"
                  style="margin-right: 12px"
                  class="btn btn-danger"
                  @click="RemoveNewBP"
                >
                  Retirer
                </button>
              </div>
              <div class="col-12 col-md-9">
                <div class="custom-search d-flex justify-content-end">
                  <div class="form-group mb-0">
                    <div class="d-flex align-items-center">
                      <input
                        v-model="searchTearm2"
                        placeholder="Chercher"
                        type="text"
                        class="form-control d-inline-block"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <vue-good-table
            :columns="columnsBP"
            :rows="BPNewRestList"
            :select-options="{
              selectOnCheckboxOnly: true,
              enabled: true,
              clearSelectionText: 'Annuler',
              selectionText: 'Colis Sélectionés',
              disableSelectInfo: true,
              selectAllByGroup: true,
            }"
            responsive
            :search-options="{
              enabled: true,
              externalQuery: searchTearm2,
            }"
            @select-all="onSelectAllNewBP"
            @selected-rows-change="selectionChangedNewBP"
          >
            <template v-slot:table-row="props">
              <template v-if="props.column.field === 'infos'">
                <span>{{ props.row.zone_name }}</span
                ><br />
                <span>{{ props.row.agency_name }}</span
                ><br />
                <span>{{ props.row.for_name }}</span
                ><br />
                <span>{{ getDate(props.row.created_at) }}</span>
              </template>
              <template v-else-if="props.column.field === 'total'">
                <span
                  ><b>{{ props.row.total }}</b> DH</span
                >
              </template>
              <template v-else-if="props.column.field === 'note_ref'">
                <b>{{ props.row.note_ref }}</b>
              </template>
              <template v-else-if="props.column.field === 'reste_amount'">
                <span
                  ><b>{{ props.row.reste_amount }}</b> DH</span
                >
              </template>
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>
          </vue-good-table>
        </div>
      </div>
    </div>
  </div>

  <div
    v-if="paimentNote.statut == 0"
    class="card mb-25 border-0 rounded-0 bg-white letter-spacing"
  >
    <div class="card-header pb-2">
      <h5>List des nouveaux colis</h5>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="m-2">
        <div class="row">
          <div
            v-if="auth.can('ADD_BP_L')"
            class="col-12 col-md-6 d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Voir</label>
            <v-select
              v-model="users.per_page"
              :options="[10, 25, 50]"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
              @input="getRows1"
            />
            <button
              v-if="paimentNote.statut == 0"
              style="margin-right: 12px"
              class="btn btn-success"
              @click="AddNewColis"
            >
              Ajouter
            </button>
          </div>
          <div class="col-12 col-md-6">
            <div class="custom-search d-flex justify-content-end">
              <div class="form-group mb-0">
                <div class="d-flex align-items-center">
                  <input
                    v-model="searchTerm1"
                    placeholder="Chercher"
                    type="text"
                    class="form-control d-inline-block"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <vue-good-table
        :columns="columns"
        :rows="rows1"
        :select-options="{
          selectOnCheckboxOnly: true,
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Colis Sélectionés',
          disableSelectInfo: true,
          selectAllByGroup: true,
        }"
        responsive
        :search-options="{
          enabled: true,
          externalQuery: searchTerm1,
        }"
        @select-all="onSelectAll"
        @selected-rows-change="selectionChanged"
      >
        <template #emptystate>
          <center>Aucune entrées correspondants trouvés</center>
        </template>
        <template #table-row="props">
          <template v-if="props.column.field === 'code'">
            <h6 v-if="props.row.replace == 1" class="text-warning">
              {{ props.row.code }}
              <i class="icon-repeat"></i>
            </h6>
            <h6 v-else-if="props.row.partial == 1" class="text-info">
              {{ props.row.code }}
              <i class="icon-corner-down-left"></i>
            </h6>
            <h6 v-else>
              {{ props.row.code }}
            </h6>
          </template>
          <template v-else-if="props.column.field === 'status'">
            <div
              v-if="
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second &&
                globalStore.globalHelper(props.row.status_second).name
              "
              class="rounded-pill fs-13 badge text-bg-black custom-badge"
              :style="{
                '--dynamic-bg': globalStore.globalHelper(
                  props.row.status_second
                ).code_color,
              }"
            >
              {{ globalStore.globalHelper(props.row.status_second).name }}
            </div>
            <div
              v-else
              class="rounded-pill fs-13 badge text-bg-black custom-badge"
              :style="{ '--dynamic-bg': props.row.code_color }"
            >
              {{ props.row.s_name }}
            </div>
          </template>
          <template v-else-if="props.column.field === 'price'">
            <b>{{ props.row.price }}</b> DH
          </template>
          <template v-else-if="props.column.field === 'delivery_time'">
            <span v-if="props.row.delivery_time" class="text-nowrap">
              {{ getDate(props.row.delivery_time) }}
            </span>
            <span v-else class="text-nowrap" />
          </template>
          <template v-else-if="props.column.field === 'liv_fees'">
            <template
              v-if="
                (props.row.status == 'DELIVERED' ||
                  props.row.status == 'DELIVERED_PARTIAL') &&
                props.row.liv_fees_livred
              "
              ><b>{{ props.row.liv_fees_livred }}</b> DH</template
            >
            <template
              v-if="
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second == 'REFUSE' &&
                props.row.liv_fees_refused
              "
              ><b>{{ props.row.liv_fees_refused }} </b> DH</template
            >
          </template>

          <template v-else-if="props.column.field === 'total'">
            <template
              v-if="
                (props.row.status == 'DELIVERED' ||
                  props.row.status == 'DELIVERED_PARTIAL') &&
                props.row.liv_fees_livred
              "
              ><b>{{ props.row.price - props.row.liv_fees_livred }} </b>
              DH</template
            >
            <template
              v-if="
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second == 'REFUSE' &&
                props.row.liv_fees_refused
              "
              ><b>{{ 0 - props.row.liv_fees_refused }} </b> DH</template
            >
          </template>
          <span v-else-if="props.column.field === 'action'">
            <div class="dropdown">
              <button
                class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="flaticon-dots"></i>
              </button>
              <ul class="dropdown-menu dropdown-menu-end">
                <li>
                  <button
                    class="dropdown-item d-flex align-items-center"
                    @click="showDetailSuivi(props.row)"
                  >
                    <i
                      class="flaticon-clock lh-1 me-8 position-relative top-1"
                    ></i>
                    Historique
                  </button>
                </li>
                <li>
                  <button
                    class="dropdown-item d-flex align-items-center"
                    @click="showDetails(props.row)"
                  >
                    <i
                      class="flaticon-view lh-1 me-8 position-relative top-1"
                    ></i>
                    Détails
                  </button>
                </li>

                <li
                  v-if="
                    auth.can('PARCELS') &&
                    (user.role_id == 1 || user.role_id == 2) &&
                    props.row.status != 'NEW_PARCEL' &&
                    props.row.status != 'WAITING_PICKUP' &&
                    (props.row.status != 'RETURNED' ||
                      props.row.status != 'RETURNED_PARTIAL') &&
                    (props.row.situation != 'Facturé' ||
                      props.row.situation != 'INVOICED')
                  "
                >
                  <button
                    type="button"
                    class="dropdown-item d-flex align-items-center"
                    @click="showUpdate(props.row)"
                  >
                    <i class="flaticon-pen"></i> Modifier Colis
                  </button>
                </li>
                <!-- <li
                  v-if="
                    props.row.situation != 'Facturé' &&
                    props.row.situation != 'INVOICED' &&
                    props.row.invoiced != 1 &&
                    auth.can('EDIT_PRICE_PARCELS')
                  "
                >
                  <button
                    v-if="auth.can('PARCELS') && auth.can('EDIT_PRICE_PARCELS')"
                    type="button"
                    class="dropdown-item d-flex align-items-center"
                    @@click="editPrice(row)"
                  >
                    <i class="flaticon-money"></i> Modifier Prix
                  </button>
                </li> -->
              </ul>
            </div>
          </span>

          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <div class="row">
        <div
          class="col-12 col-md-6 d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>Voir</label>
          <v-select
            v-model="users.per_page"
            :options="[10, 25, 50]"
            :clearable="false"
            class="per-page-selector d-inline-block mx-50"
            @input="getRows1"
          />
          <label>de {{ users.total }} entités</label>
        </div>
        <div class="col-12 col-md-6">
          <PaginatorContent
            :pagination="users"
            :offset="9"
            @paginate="getRows1"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header pb-2">
      <h5>List des colis ajoutés</h5>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="m-2">
        <div class="row">
          <div
            v-if="auth.can('ADD_BP_L')"
            class="col-12 col-md-6 d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Voir</label>
            <v-select
              v-model="users1.per_page"
              :options="[10, 25, 50]"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
              @input="getRows2()"
            />
            <button
              v-if="paimentNote.statut == 0"
              style="margin-right: 12px"
              class="btn btn-danger"
              @click="RemoveNewColis"
            >
              Supprimer
            </button>
          </div>
          <div class="col-12 col-md-6">
            <div class="custom-search d-flex justify-content-end">
              <div class="form-group mb-0">
                <div class="d-flex align-items-center">
                  <input
                    v-model="searchTerm2"
                    placeholder="Chercher"
                    type="text"
                    class="form-control d-inline-block"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <vue-good-table
        :columns="columns"
        :rows="rows2"
        :select-options="{
          selectOnCheckboxOnly: true,
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Colis Sélectionés',
          disableSelectInfo: true,
          selectAllByGroup: true,
        }"
        responsive
        :search-options="{
          enabled: true,
          externalQuery: searchTerm2,
        }"
        @select-all="onSelectAllColis"
        @selected-rows-change="selectionChangedColis"
      >
        <template #emptystate>
          <center>Aucune entrées correspondants trouvés</center>
        </template>
        <template #table-row="props">
          <template v-if="props.column.field === 'code'">
            <h6 v-if="props.row.replace == 1" class="text-warning">
              {{ props.row.code }}
              <i class="icon-repeat"></i>
            </h6>
            <h6 v-else-if="props.row.partial == 1" class="text-info">
              {{ props.row.code }}
              <i class="icon-corner-down-left"></i>
            </h6>
            <h6 v-else>
              {{ props.row.code }}
            </h6>
          </template>
          <template v-else-if="props.column.field === 'status'">
            <div
              v-if="
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second &&
                globalStore.globalHelper(props.row.status_second).name
              "
              class="rounded-pill fs-13 badge text-bg-black custom-badge"
              :style="{ '--dynamic-bg': ColorStatu(props.row.status_second) }"
            >
              {{ resolveStatuParcel(props.row.status_second) }}
            </div>
            <div
              class="rounded-pill fs-13 badge text-bg-black custom-badge"
              :style="{ '--dynamic-bg': props.row.code_color }"
            >
              {{ props.row.s_name }}
            </div>
          </template>
          <template v-else-if="props.column.field === 'price'">
            <b>{{ props.row.price }}</b> DH
          </template>
          <template v-else-if="props.column.field === 'delivery_time'">
            <span v-if="props.row.delivery_time" class="text-nowrap">
              {{ getDate(props.row.delivery_time) }}
            </span>
            <span v-else class="text-nowrap" />
          </template>
          <template v-else-if="props.column.field === 'liv_fees'">
            <template
              v-if="
                (props.row.status == 'DELIVERED' ||
                  props.row.status == 'DELIVERED_PARTIAL') &&
                props.row.liv_fees_livred
              "
              ><b>{{ props.row.liv_fees_livred }}</b> DH</template
            >
            <template
              v-if="props.row.status == 'REFUSE' && props.row.liv_fees_refused"
              ><b>{{ props.row.liv_fees_refused }} </b> DH</template
            >
          </template>
          <template v-else-if="props.column.field === 'total'">
            <template
              v-if="
                (props.row.status == 'DELIVERED' ||
                  props.row.status == 'DELIVERED_PARTIAL') &&
                props.row.liv_fees_livred
              "
              ><b>{{ props.row.price - props.row.liv_fees_livred }} </b>
              DH</template
            >
            <template
              v-if="props.row.status == 'REFUSE' && props.row.liv_fees_refused"
              ><b>{{ 0 - props.row.liv_fees_refused }} </b> DH</template
            >
          </template>
          <span v-else-if="props.column.field === 'action'">
            <div class="dropdown">
              <button
                class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="flaticon-dots"></i>
              </button>
              <ul class="dropdown-menu dropdown-menu-end">
                <li>
                  <button
                    class="dropdown-item d-flex align-items-center"
                    @click="showDetailSuivi(props.row)"
                  >
                    <i
                      class="flaticon-clock lh-1 me-8 position-relative top-1"
                    ></i>
                    Historique
                  </button>
                </li>
                <li>
                  <button
                    class="dropdown-item d-flex align-items-center"
                    @click="showDetails(props.row)"
                  >
                    <i
                      class="flaticon-view lh-1 me-8 position-relative top-1"
                    ></i>
                    Détails
                  </button>
                </li>

                <li
                  v-if="
                    auth.can('PARCELS') &&
                    (user.role_id == 1 || user.role_id == 2) &&
                    props.row.status != 'NEW_PARCEL' &&
                    props.row.status != 'WAITING_PICKUP' &&
                    (props.row.status != 'RETURNED' ||
                      props.row.status != 'RETURNED_PARTIAL') &&
                    (props.row.situation != 'Facturé' ||
                      props.row.situation != 'INVOICED')
                  "
                >
                  <button
                    type="button"
                    class="dropdown-item d-flex align-items-center"
                    @click="showUpdate(props.row)"
                  >
                    <i class="flaticon-pen"></i> Modifier Colis
                  </button>
                </li>
                <!-- <li
                  v-if="
                    props.row.situation != 'Facturé' &&
                    props.row.situation != 'INVOICED' &&
                    props.row.invoiced != 1 &&
                    auth.can('EDIT_PRICE_PARCELS')
                  "
                >
                  <button
                    v-if="auth.can('PARCELS') && auth.can('EDIT_PRICE_PARCELS')"
                    type="button"
                    class="dropdown-item d-flex align-items-center"
                    @@click="editPrice(row)"
                  >
                    <i class="flaticon-money"></i> Modifier Prix
                  </button>
                </li> -->
              </ul>
            </div>
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <div class="row">
        <div
          class="col-12 col-md-6 d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>Voir</label>
          <v-select
            v-model="users1.per_page"
            :options="[10, 25, 50]"
            :clearable="false"
            class="per-page-selector d-inline-block mx-50"
            @input="getRows2()"
          />
          <label>de {{ users1.total }} entités</label>
        </div>
        <div class="col-12 col-md-6">
          <PaginatorContent
            :pagination="users1"
            :offset="9"
            @paginate="getRows2"
          />
        </div>
      </div>
    </div>
  </div>

  <!-- Status Update Modal using Bootstrap -->
  <div
    class="modal fade"
    id="modal_detail_suivi"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h5 class="modal-title">Historique Colis</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Fermer"
          ></button>
        </div>
        <div class="modal-body">
          <HistoryColis
            v-if="colisId"
            :colisId="colisId"
            :isOpen="isOpen"
            :status="statuts"
          />
        </div>
      </div>
    </div>
  </div>

  <!-- Status details colios -->
  <div
    class="modal fade"
    id="modal_detail_colis"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h5 class="modal-title">Détails Colis</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Fermer"
          ></button>
        </div>
        <div class="modal-body">
          <DetailsColis
            v-if="coliDetails"
            :coliDetails="coliDetails"
            :isOpen="isOpen"
          />
        </div>
      </div>
    </div>
  </div>

  <!-- Update Parcel Modal using Bootstrap -->
  <div class="modal fade" id="modal_update" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h5 class="modal-title">Modifier Colis</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Fermer"
          ></button>
        </div>
        <div class="modal-body">
          <UpdateParcel
            v-if="rowUpdate"
            :rowColis="rowUpdate"
            :getRecords="getRecords"
            :isOpenEdit="isOpenEdit"
            :hideModal="hideModal"
          />
        </div>
      </div>
    </div>
  </div>

  <!-- Update Fees Modal using Bootstrap -->
  <!-- <div class="modal fade" id="modal_fees_edit" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h5 class="modal-title">Modifier les frais</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Fermer"
          ></button>
        </div>
        <div class="modal-body">
          <UpdateFeesParcel
            v-if="rowUpdateFees"
            :rowColis="rowUpdateFees"
            :getRecords="getRecords"
            :isOpenFees="isOpenFees"
            :hideModal="hideModal"
          />
        </div>
      </div>
    </div>
  </div> -->
</template>


<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import router from "@/router";
import { useAuthStore } from "@/stores/auth";
import api from "@/utils/axios";
import moment from "moment";
import { defineComponent, ref, reactive, onMounted, nextTick } from "vue";
import { useGlobalStore } from "@/stores/global";
import { useRoute } from "vue-router";
import { Modal } from "bootstrap";

import HistoryColis from "@/components/Colis/HistoryColis.vue";
import UpdateParcel from "@/components/Colis/UpdateParcel.vue";
import DetailsColis from "@/components/Colis/DetailsColis.vue";
// import UpdateFeesParcel from "@/components/Colis/UpdateFeesParcel.vue";

export default defineComponent({
  name: "EditPayment",
  components: {
    HistoryColis,
    UpdateParcel,
    DetailsColis,
    // UpdateFeesParcel,
  },
  setup() {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;
    const globalStore = useGlobalStore();
    const route = useRoute();

    const AgenciesList = ref([]);
    const ClientsList = ref([]);
    const AgencyStockList = ref([]);
    const isLoader = ref(true);
    const searchTerm1 = ref("");
    const searchTerm2 = ref("");
    const searchTearm = ref("");
    const searchTearm2 = ref("");
    const pageLength = ref(10);
    const pageLength2 = ref(10);
    // loading:false
    const columns = [
      { label: "Code Suivi", field: "code" },
      { label: "Client", field: "customer_name" },
      { label: "Téléphone", field: "customer_phone" },
      { label: "Date de livraison", field: "delivery_time" },
      { label: "Ville", field: "city_name" },
      { label: "Status", field: "status" },
      { label: "Prix", field: "price" },
      { label: "Frais", field: "liv_fees" },
      { label: "Total", field: "total" },
      { label: "Actions", field: "action" },
    ];
    const columnsBP = [
      { label: "Ref", field: "note_ref" },
      { label: "Infos", field: "infos" },
      { label: "Total", field: "total" },
      { label: "Reste", field: "reste_amount" },
    ];
    const SelectedRows = ref([]);
    const SelectedNewRows = ref([]);
    const SelectedRowsBP = ref([]);
    const SelectedNewRowsBP = ref([]);
    const codeColis = ref("");
    const refReception = ref("");
    const rows1 = ref([]);
    const rows2 = ref([]);
    const paimentNote = ref<any>({});
    const PBRestList = ref([]);
    const BPNewRestList = ref([]);
    const color = ref("");
    const rowID = ref(null);
    const row = ref({});
    const users = reactive({
      searchTerm: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });
    const users1 = reactive({
      searchTerm: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });
    const PriceColis = ref({ id: "", price: "" });

    const statuts = localStorage.getItem("statutsList")
      ? JSON.parse(localStorage.getItem("statutsList") || "")
      : [];
    const getDate = (value: string) => {
      return moment(String(value)).format("YYYY-MM-DD HH:mm");
    };

    const ColorStatu = async (status: string) => {
      try {
        const res = await api.get(`/api/auth/ColorStatus?status=${status}`);
        color.value = res.data;
        return color.value;
      } catch (e) {
        return "";
      }
    };

    const resolveStatu = (status: string) => {
      switch (status) {
        case "POSTPONED":
          return "Reporté";
        case "DELIVERED":
          return "Livré";
        case "PAID":
          return "Payé";
        case "NOT_PAID":
          return "Non Payé";
        case "Payé":
          return "info";
        case "CANCELED":
          return "Annulé";
        case "UNREACHABLE":
          return "Injoignable";
        case "RETURNED":
          return "Retourné";
        case "RECEIVED":
          return "Reçu";
        case "OUT_OF_AREA":
          return "Hors-zone";
        case "NOANSWER":
          return "Pas de réponse + SMS";
        case "SENTED":
          return "Expédié";
        case "REFUSE":
          return "Refusé";
        default:
          return status;
      }
    };

    const SearchColis = async () => {
      isLoader.value = true;
      try {
        const res = await api.get(`/api/auth/SearchColisNote`, {
          params: {
            cstmr_id: router.currentRoute.value.params.id,
            code_colis: codeColis.value,
          },
        });
        isLoader.value = false;
        if (res.data.message === "success") {
          const audio = new Audio("/sound.mp3");
          audio.play();
          codeColis.value = "";
        } else if (res.data.message === "not exist") {
          const audio = new Audio("/erro.mp3");
          audio.play();
          showToast("Colis n'existe pas", "error");
        }
      } catch {
        showToast("Oops... Something went wrong! Pleaz try again", "error");
      }
    };

    function onSelectAll(params) {
      console.log(params);
      SelectedRows.value = params.selectedRows;
    }
    function selectionChanged(params) {
      SelectedRows.value = params.selectedRows;
    }
    function onSelectAllColis(params) {
      SelectedNewRows.value = params.selectedRows;
    }
    function selectionChangedColis(params) {
      SelectedNewRows.value = params.selectedRows;
    }
    function onSelectAllBP(params) {
      SelectedRowsBP.value = params.selectedRows;
    }
    function selectionChangedBP(params) {
      SelectedRowsBP.value = params.selectedRows;
    }
    function onSelectAllNewBP(params) {
      SelectedNewRowsBP.value = params.selectedRows;
    }
    function selectionChangedNewBP(params) {
      SelectedNewRowsBP.value = params.selectedRows;
    }

    onMounted(async () => {
      getData();
    });

    const getData = async () => {
      isLoader.value = true;
      try {
        const res = await api.get(`/api/auth/show_bon_pay`, {
          params: { ref: route.params.refNote },
        });
        paimentNote.value = res.data.Note;
        await getRows1();
        await getRows2();
        const resBP = await api.get(`/api/auth/payment_reste_list`, {
          params: { ref: route.params.refNote },
        });
        PBRestList.value = resBP.data;
        const resNewBP = await api.get(`/api/auth/ListNoteInNote`, {
          params: { ref: route.params.refNote },
        });
        BPNewRestList.value = resNewBP.data;
      } finally {
        isLoader.value = false;
      }
    };

    const getRows1 = async (page = 1) => {
      users.current_page = page;
      const res = await api.get(
        `/api/auth/payment_colis_list?searchTerm=${users.searchTerm}&page=${users.current_page}&per_page=${users.per_page}`,
        { params: { ref: route.params.refNote } }
      );
      rows1.value = res.data.users.data;
      Object.assign(users, res.data.users);
    };

    const getRows2 = async (page = 1) => {
      users1.current_page = page;
      const res = await api.get(
        `/api/auth/colis_in_note?searchTerm=${users1.searchTerm}&page=${users1.current_page}&per_page=${users1.per_page}`,
        { params: { ref: route.params.refNote } }
      );
      rows2.value = res.data.users.data;
      Object.assign(users1, res.data.users);
    };

    const AddNewColis = async () => {
      console.log(SelectedRows.value);
      if (SelectedRows.value.length === 0) {
        showToast("Vous pouvez pas ajouter à ce bon", "error");
        return;
      }
      const data = new FormData();
      data.append("colis", JSON.stringify(SelectedRows.value));
      data.append("note_ref", String(route.params.refNote));
      try {
        const res = await api.post(`/api/auth/add_colis_payment`, data);
        if (res.data.message === "success") {
          const audio = new Audio("/sound.mp3");
          audio.play();
          showToast("ajouté avec succès", "success");
          await getData();
        } else {
          showToast("Oops... Something went wrong! Pleaz try again", "error");
        }
      } catch {
        showToast("Oops... Something went wrong! Pleaz try again", "error");
      }
    };

    const RemoveNewColis = async () => {
      if (SelectedNewRows.value.length === 0) {
        showToast("Vous pouvez pas ajouter à ce bon", "error");
        return;
      }
      const data = new FormData();
      data.append("colis", JSON.stringify(SelectedNewRows.value));
      data.append("note_ref", String(route.params.refNote));
      try {
        const res = await api.post(`/api/auth/remove_colis_list`, data);
        if (res.data.message === "success") {
          const audio = new Audio("/sound.mp3");
          audio.play();
          showToast("Supprimé avec succès", "success");
          await getData();
        } else {
          showToast("Oops... Something went wrong! Pleaz try again", "error");
        }
      } catch {
        showToast("Oops... Something went wrong! Pleaz try again", "error");
      }
    };

    const AddNewBP = async () => {
      if (SelectedRowsBP.value.length === 0) {
        showToast("Vous pouvez pas ajouter à ce bon", "error");
        return;
      }
      const data = new FormData();
      data.append("notes", JSON.stringify(SelectedRowsBP.value));
      data.append("note_ref", String(route.params.refNote));
      try {
        const res = await api.post(`/api/auth/AddNoteToNote`, data);
        if (res.data.message === "success") {
          const audio = new Audio("/sound.mp3");
          audio.play();
          showToast("ajouté avec succès", "success");
          await getData();
        } else {
          showToast("Oops... Something went wrong! Pleaz try again", "error");
        }
      } catch {
        showToast("Oops... Something went wrong! Pleaz try again", "error");
      }
    };

    const RemoveNewBP = async () => {
      if (SelectedNewRowsBP.value.length === 0) {
        showToast("Vous pouvez pas ajouter à ce bon", "error");
        return;
      }
      const data = new FormData();
      data.append("notes", JSON.stringify(SelectedNewRowsBP.value));
      data.append("note_ref", String(route.params.refNote));
      try {
        const res = await api.post(`/api/auth/RemoveNoteFromNote`, data);
        if (res.data.message === "success") {
          const audio = new Audio("/sound.mp3");
          audio.play();
          showToast("Supprimé avec succès", "success");
          await getData();
        } else {
          showToast("Oops... Something went wrong! Pleaz try again", "error");
        }
      } catch {
        showToast("Oops... Something went wrong! Pleaz try again", "error");
      }
    };

    const colisId = ref(null);
    const isOpen = ref(false);
    const coliDetails = ref<any>({});

    async function showDetailSuivi(row) {
      isOpen.value = false;
      colisId.value = null;

      colisId.value = row.id;
      const modalEl = document.getElementById("modal_detail_suivi");
      if (modalEl) {
        const modal = new Modal(modalEl);
        isOpen.value = true;
        modal.show();
      }
      // TODO: Open history modal
    }

    async function showDetails(row) {
      isOpen.value = false;
      coliDetails.value = null;
      isOpen.value = false;
      coliDetails.value = row;

      const modalEl = document.getElementById("modal_detail_colis");
      if (modalEl) {
        const modal = new Modal(modalEl);
        isOpen.value = true;
        modal.show();
      }
      // TODO: Open info modal
    }

    const rowUpdate = ref(null);
    const isOpenEdit = ref(false);
    // Show update modal
    async function showUpdate(row) {
      rowUpdate.value = null;
      isOpenEdit.value = false;
      rowUpdate.value = row;
      nextTick(() => {
        const modalEl = document.getElementById("modal_update");
        console.log(modalEl);
        if (modalEl) {
          isOpenEdit.value = true; // triggers watcher in child

          const modal = new Modal(modalEl);
          modal.show();
        }
      });
    }

    const FindStatus = ($row: any) => {
      if ($row.status === "IN_PROGRESS") {
        return (window as any).globalHelper($row.status_second).name;
      }
      return $row.status;
    };

    const EditPriceColis = async () => {
      const data = new FormData();
      data.append("id_colis", PriceColis.value.id);
      data.append("price", PriceColis.value.price);
      data.append("user_id", user?.id);
      try {
        const res = await api.post(
          `/api/auth/coli_edit_price/${PriceColis.value.id}`,
          data
        );
        if (res.data.message === "success") {
          await getRows1();
          showToast("Modifié avec succès", "success");
        } else if (res.data.message === "no edit") {
          showToast("Champs Invalide", "error");
        } else if (res.data.message === "no access") {
          showToast(
            "Vous avez pas les droits nécessaire pour modifier ce colis",
            "error"
          );
        } else if (res.data.message === "no parcel") {
          showToast("Ce colis n'existe pas", "error");
        }
      } catch {
        showToast("Oops... Something went wrong! Pleaz try again", "error");
      }
    };
    function resolveStatuParcel(status) {
      if (status === "POSTPONED") return "Reporté";
      if (status === "DELIVERED") return "Livré";
      if (status === "PAID") return "Payé";
      if (status === "NOT_PAID") return "Non Payé";
      if (status === "Payé") return "Payé";
      if (status === "CANCELED") return "Annulé";
      if (status === "UNREACHABLE") return "Injoignable";
      if (status === "POSTPONED") return "Reporté";
      if (status === "RETURNED") return "Retourné";
      if (status === "RECEIVED") return "Reçu";
      if (status === "OUT_OF_AREA") return "Hors-zone";
      if (status === "NOANSWER") return "Pas de réponse + SMS";
      if (status === "SENTED") return "Expédié";
      if (status === "REFUSE") return "Refusé";
      if (status === "ONV") return "En Voyage";
      if (status === "INT") return "Client intéréssé";
      if (status === "POSTPONED_TEAM") return "Reporté ( SUIVI )";
      if (status === "CANCELED_TEAM") return "Annulé ( SUIVI )";
      if (status === "VOICEMAIL_TEAM") return "Boite Vocal ( SUIVI )";
      if (status === "EN") return "Erreur Numéro";
      return status;
    }

    function hideModal(idModal) {
      const modalEl = document.getElementById(idModal);
      const modal = Modal.getInstance(modalEl) || new Modal(modalEl);
      if (modal) {
        modal.hide();
      }
    }

    return {
      AgenciesList,
      ClientsList,
      AgencyStockList,
      isLoader,
      searchTerm1,
      searchTerm2,
      searchTearm,
      searchTearm2,
      pageLength,
      pageLength2,
      columns,
      columnsBP,
      SelectedRows,
      SelectedNewRows,
      SelectedRowsBP,
      SelectedNewRowsBP,
      codeColis,
      refReception,
      rows1,
      rows2,
      paimentNote,
      PBRestList,
      BPNewRestList,
      color,
      rowID,
      row,
      users,
      users1,
      PriceColis,
      AddNewColis,
      RemoveNewColis,
      AddNewBP,
      RemoveNewBP,
      getDate,
      auth,
      user,
      SearchColis,
      onSelectAll,
      selectionChanged,
      onSelectAllColis,
      selectionChangedColis,
      onSelectAllBP,
      selectionChangedBP,
      onSelectAllNewBP,
      selectionChangedNewBP,
      getData,
      getRows1,
      getRows2,
      globalStore,
      showDetailSuivi,
      showDetails,
      showUpdate,
      FindStatus,
      ColorStatu,
      resolveStatuParcel,

      colisId,
      isOpen,
      coliDetails,
      rowUpdate,
      isOpenEdit,
      EditPriceColis,
      // rowUpdateFees,
      // isOpenFees,
      // showUpdateFees,
      // hideModal,
      getRecords: getData,
      // getRowDetails: getRowDetails,
      hideModal,
      statuts,
    };
  },
});
</script>

